import { useParams } from 'react-router-dom';

import Profile from '@modules/user/components/Profile';

export default function User() {
  const { userId } = useParams();

  return <Profile userId={userId as string} />;
}
